var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Divider, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
export const useStyles = makeStyles((theme) => ({
    root: ({ margin }) => ({
        backgroundColor: theme.palette.dividerUnsupported.regular,
        marginTop: theme.spacing(margin),
        marginBottom: theme.spacing(margin),
    }),
    bold: {
        backgroundColor: theme.palette.dividerUnsupported.bold,
        height: 2,
    },
}));
export default (_a) => {
    var { variant = "regular", margin = 0 } = _a, otherProps = __rest(_a, ["variant", "margin"]);
    const classes = useStyles({ margin });
    return (React.createElement(Divider, Object.assign({ className: clsx(classes.root, variant === "bold" && classes.bold) }, otherProps)));
};
//# sourceMappingURL=FTLDivider.js.map